import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core'
import {
    Subscription, DataLoaderService, Data, ResetService, PriceCalculationService, ProgressBarService, SummaryService
} from '../selectable-tabs/expert-screen-components/expert-service-call.index';
import { ImageLoaderService } from '../index';

@Component({
    selector: 'special-mode',
    templateUrl: './special-mode.template.html',
    styleUrls: ['./special-mode.component.css']
})

export class SpecialModeComponent {

    public baumuster; pricingDate; productionDate; vehicleDescription: string; vehClass: string;

    private subscription: Subscription;
    private colorSelected: string = "";
    private addColorSelected: string = "";
    private upholsterySelected: string = "";
    private factoryIndex = [];
    private localIndex = [];
    private packageIndex = [];
    private indexCheckFlag: boolean = false;
    private factorySelected = [];
    private localSelected = [];
    private packageSelected = [];
    private specialFactoryOptions: any = [];
    private specialLocalOptions: any = [];
    private specialPackageOptions: any = [];
    private specialColorOptions: string;
    private specialAdcolorOptions: string;
    private specialTrimOptions: string;
    private specialRimOptions: string;
    private specialUpholsteryOptions: string;
    private regExp: any;
    private duplicate: number;
    private pattern: number;
    private alphaNumericPattern: number;
    private count: number;
    private indexCount: number;
    private duplicateErrorVisibility: boolean = true;
    private patternErrorVisibility: boolean = true;
    private alphaNumericErrorVisibility: boolean = true;
    private inputMode: string;
    private imageURL: string;
    private typeOfDrive: string;
    private extMaterialGrp: string;

    private redProgressBar: boolean = false;
    private yellowProgressBar: boolean = false;
    private greenProgressBar: boolean = false;
    private iterFac: number[] = [];
    private iterLoc: number[] = [];
    private iterPac: number[] = [];

    constructor(private translate: TranslateService, private imageLoaderService: ImageLoaderService,
        private resetService: ResetService, private priceService: PriceCalculationService,
        private dataLoaderService: DataLoaderService, private progressBarService: ProgressBarService,
        private summaryService: SummaryService) {
        // this.translate.addLangs(["English", "Deutsche", "한국어", "Español"]);
        // const browserLang = this.translate.getBrowserLang();
        // this.translate.use(browserLang.match(/English|Deutsche|한국어|Español/) ? browserLang : 'English');
        this.typeOfDrive = this.dataLoaderService.vehicleInfo.driveType;
        this.extMaterialGrp = this.dataLoaderService.vehicleInfo.materialGroupExt;
        this.translate.addLangs(this.languageExtract());
        // this.translate.addLangs(["English", "Deutsche", "한국어", "Español"]);
        const browserLang = this.translate.getBrowserLang();
        // this.translate.use(browserLang.match(/English|Deutsche/) ? browserLang : 'English');
        this.translate.use(this.displayLanguage());
        this.regExp = new RegExp('^([a-zA-Z0-9]{3}|[a-zA-Z0-9]{2}|[a-zA-Z0-9]{1})$');
        for (let i = 0; i < 18; i++) {
            this.iterFac.push(i);
            this.iterLoc.push(i);
            this.iterPac.push(i);
        }
        if (this.dataLoaderService.vehicleInfo.savedConfig !== "") {
            let data = JSON.parse(this.dataLoaderService.vehicleInfo.savedConfig)

            //color
            if (data.lowerPaint != "000") {
                this.colorSelected = data.lowerPaint
                this.specialColorOptions = this.colorSelected;

            }
            else {
                this.colorSelected = "";
            }
            this.priceService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.colorSelected] });
            //additional color
            if (data.upperPaint != "000") {
                this.addColorSelected = data.upperPaint
                this.specialAdcolorOptions = this.addColorSelected;

            }
            else {
                this.addColorSelected = "";
            }
            this.priceService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.addColorSelected] });
            //upholstery
            if (data.upholstery != "000") {
                this.upholsterySelected = data.upholstery
                this.specialUpholsteryOptions = this.upholsterySelected;

            }
            else {
                this.upholsterySelected = "";
            }
            this.priceService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.upholsterySelected] });
            //factory
            if (data.factoryOptions != [] && data.factoryOptions != undefined) {
                for (let i = 0; i < data.factoryOptions.length; i++) {
                    this.specialFactoryOptions[i] = data.factoryOptions[i];
                    this.factorySelected.push(data.factoryOptions[i])
                }
            }
            else {
                this.factorySelected = [];
            }

            this.priceService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.factorySelected] });

            //local
            if (data.localOptions != [] && data.localOptions != undefined) {
                for (let i = 0; i < data.localOptions.length; i++) {
                    this.specialLocalOptions[i] = data.localOptions[i];
                    this.localSelected.push(data.localOptions[i])
                }
            }
            else {
                this.localSelected = [];
            }
            this.priceService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.localSelected] });

            //package
            if (data.packageOptions != [] && data.packageOptions != undefined) {
                for (let i = 0; i < data.packageOptions.length; i++) {
                    this.specialPackageOptions[i] = data.packageOptions[i];
                    this.packageSelected.push(data.packageOptions[i])
                }
            }
            else {
                this.packageSelected = [];
            }
            this.priceService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.packageSelected] });
        }
    }

    displayLanguage() {
        let defaultLanguage;
        this.dataLoaderService.data.availableLanguages.forEach(element => {
          if (this.dataLoaderService.vehicleInfo.language === element.language) {
            defaultLanguage = element.language;
          }
        });
        return defaultLanguage;
      }
    languageExtract() {
        let langList = [];
        this.dataLoaderService.data.availableLanguages.forEach(element => {
            langList.push(element.name);
        });
        return langList;
    }

    ngOnInit() {
        this.redProgressBar = true;
        this.progressBarService.progressBarValidation();
        // if ((this.dataLoaderService.vehicleInfo.urlFlag === '0') && (this.dataLoaderService.vehicleInfo.preSeriesModeFlag === 'X')) {
        this.baumuster = this.dataLoaderService.vehicleInfo.baumuster;
        this.vehicleDescription = this.dataLoaderService.vehicleInfo.vehicleDescription.split('+').join(' ');;
        this.vehClass = this.dataLoaderService.vehicleInfo.vehicleClass;

        // } else {
        //     this.baumuster = this.dataLoaderService.vehicleInfo.baumuster;
        //     this.vehicleDescription = this.dataLoaderService.data.vehInfo[0].vehicle.split('+').join(' ');
        //     this.vehClass = this.dataLoaderService.data.vehInfo[0].vehicleClass;
        // }
        this.pricingDate = this.dataLoaderService.vehicleInfo.pricingDate.substring(6) + '/' + this.dataLoaderService.vehicleInfo.pricingDate.substring(4, 6) + '/' + this.dataLoaderService.vehicleInfo.pricingDate.substring(0, 4);
        this.productionDate = this.dataLoaderService.vehicleInfo.productionDate.substring(6) + '/' + this.dataLoaderService.vehicleInfo.productionDate.substring(4, 6) + '/' + this.dataLoaderService.vehicleInfo.productionDate.substring(0, 4);

        //Reset
        this.subscription = this.resetService.notifyObservable$.subscribe((res) => {

            this.specialColorOptions = "";
            this.specialAdcolorOptions = "";
            this.specialRimOptions = "";
            this.specialTrimOptions = "";
            this.specialUpholsteryOptions = "";
            this.specialFactoryOptions = [];
            this.specialLocalOptions = [];
            this.specialPackageOptions = [];

            this.factorySelected = [];
            this.localSelected = [];
            this.packageSelected = [];
            this.colorSelected = null;
            this.addColorSelected = null;
            
            this.upholsterySelected = null;

            this.progressBarService.illuminateRed();
        });

        this.subscription = this.progressBarService.notifyObservableRed$.subscribe((res) => {
            this.redProgressBar = true;
            this.greenProgressBar = false;
            this.yellowProgressBar = false;
        });
        this.subscription = this.progressBarService.notifyObservableYellow$.subscribe((res) => {
            this.redProgressBar = false;
            this.greenProgressBar = false;
            this.yellowProgressBar = true;
        });
        this.subscription = this.progressBarService.notifyObservableGreen$.subscribe((res) => {
            this.redProgressBar = false;
            this.greenProgressBar = true;
            this.yellowProgressBar = false;
        });
    }

    addFac() {
        let a: number;
        for (let j of this.iterFac) {
            a = j
        }
        for (let j = 1; j <= 6; j++) {
            this.iterFac.push(a + j);
        }

    }

    remFac() {
        let a: number;
        for (let j of this.iterFac) {
            a = j
        }
        this.iterFac.splice(a)

    }
    addLoc() {
        let a: number;
        for (let j of this.iterLoc) {
            a = j
        }
        for (let j = 1; j <= 6; j++) {
            this.iterLoc.push(a + j);
        }

    }

    remLoc() {
        let a: number;
        for (let j of this.iterLoc) {
            a = j
        }
        this.iterLoc.splice(a)

    }
    addPac() {
        let a: number;
        for (let j of this.iterPac) {
            a = j
        }
        for (let j = 1; j <= 6; j++) {
            this.iterPac.push(a + j);
        }

    }

    remPac() {
        let a: number;
        for (let j of this.iterPac) {
            a = j
        }
        this.iterPac.splice(a)
    }


    onColorOptionClick(item) {
        let regExpAlphaNumeric = /^[A-Za-z0-9]+$/;
        this.alphaNumericPattern = 0;
        this.alphaNumericErrorVisibility = true;

        this.pattern = 0;
        this.patternErrorVisibility = true;

        this.inputMode = "color";
        if (item != undefined) {
            if (item.length > 3) {
                this.pattern += 1;
                this.showError();
                this.specialColorOptions = null;
                this.colorSelected = "";

            }
            if (!item.match(regExpAlphaNumeric)) {
                this.alphaNumericPattern += 1;
                this.showError();
                this.specialColorOptions = null;
                this.colorSelected = "";
            } else {
                this.colorSelected = item;

            }
        }

        this.priceService.notifyNormalCompItem({ fromComponent: "normalColor", data: [this.colorSelected] });
        //this.progressBarService.progressBarValidation();

    }


    onAdcolorOptionClick(item) {
        let regExpAlphaNumeric = /^[A-Za-z0-9]+$/;
        this.alphaNumericPattern = 0;
        this.alphaNumericErrorVisibility = true;

        this.pattern = 0;
        this.patternErrorVisibility = true;
        this.inputMode = "adcolor";
        if (item != undefined) {
            if (item.length > 3) {
                this.pattern += 1;
                this.showError();
                this.specialAdcolorOptions = null;
                this.addColorSelected = "";
            }
            if (!item.match(regExpAlphaNumeric)) {
                this.alphaNumericPattern += 1;
                this.showError();
                this.specialAdcolorOptions = null;
                this.addColorSelected = "";
            } else {
                this.addColorSelected = item;
            }
        }
        this.priceService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [this.addColorSelected] });
        //this.progressBarService.progressBarValidation();
    }

    onUpholsteryOptionClick(item) {
        let regExpAlphaNumeric = /^[A-Za-z0-9]+$/;
        this.alphaNumericPattern = 0;
        this.alphaNumericErrorVisibility = true;

        this.pattern = 0;
        this.patternErrorVisibility = true;
        this.inputMode = "upholstery";
        if (item != undefined) {
            if (item.length > 3) {
                this.pattern += 1;
                this.showError();
                this.specialUpholsteryOptions = null;
                this.upholsterySelected = "";
            }
            if (!item.match(regExpAlphaNumeric)) {
                this.alphaNumericPattern += 1;
                this.showError();
                this.specialUpholsteryOptions = null;
                this.upholsterySelected = "";
            }
            else {
                this.upholsterySelected = item;

            }
        }
        this.priceService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [this.upholsterySelected] });
        // this.progressBarService.progressBarValidation();
    }

    onFactoryOptionClick(item, index) {
        let regExpAlphaNumeric = /^[A-Za-z0-9]+$/;
        this.alphaNumericPattern = 0;
        this.alphaNumericErrorVisibility = true;

        this.indexCheckFlag = false;
        this.indexCount = 0;
        this.count = 0;
        this.duplicate = 0;
        this.pattern = 0;
        this.patternErrorVisibility = true;
        this.duplicateErrorVisibility = true;
        this.inputMode = "factory";
        for (let j = 0; j < this.factoryIndex.length; j++) {
            if (index == this.factoryIndex[j]) {
                this.indexCount++;
            }
        }
        if (this.indexCount !== this.factoryIndex.length) {
            this.indexCheckFlag = true;
        }

        //pattern matching
        if (item != undefined) {
            if (item.length > 3) {
                this.pattern += 1;
                this.showError();
                this.specialFactoryOptions[index] = null;
                item = "";
            } if (!item.match(regExpAlphaNumeric)) {
                this.alphaNumericPattern += 1;
                this.showError();
                this.specialFactoryOptions[index] = null;
                this.factorySelected[index] = "";
            } else {
                //duplicate error
                for (let j = 0; j < this.factorySelected.length; j++) {
                    if (item !== this.factorySelected[j]) {
                        this.count++;

                    }
                }
                if (this.count == this.factorySelected.length && item != "") {
                    this.factorySelected.push(item);
                    this.factoryIndex.push(index);
                    
                }
                else {
                    if (this.count == 0 && this.indexCount == 0) {
                        this.indexCheckFlag = false;
                    }
                    if (this.indexCount == 0 && this.count != 0) {
                        this.indexCheckFlag = false;
                    }
                    if (this.indexCount !== 0 && this.count == 0) {
                        this.indexCheckFlag = true;
                    }
                    if (!this.indexCheckFlag && item != "") {
                        this.duplicate += 1;
                        this.showError();
                        this.specialFactoryOptions[index] = null;
                        
                    }

                }
                
            }
            for (let i = 0; i < this.factorySelected.length; i++) {
                if (this.factorySelected[i] === "" ) {
                    this.factorySelected.splice(i, 1);
                }
            }
        }
        this.priceService.notifyNormalCompItem({ fromComponent: "normalFactory", data: [this.factorySelected] });

        //this.progressBarService.progressBarValidation();
    }
    showError() {
        if (this.duplicate > 0) {
            this.duplicateErrorVisibility = false;
            this.patternErrorVisibility = true;
            this.alphaNumericErrorVisibility = true;

        }
        if (this.pattern > 0) {
            this.patternErrorVisibility = false;
            this.duplicateErrorVisibility = true;
            this.alphaNumericErrorVisibility = true;
        }
        if (this.alphaNumericPattern > 0) {
            this.patternErrorVisibility = true;
            this.duplicateErrorVisibility = true;
            this.alphaNumericErrorVisibility = false;
        }
    }
    onLocalOptionClick(item, index) {
        let regExpAlphaNumeric = /^[A-Za-z0-9]+$/;
        this.alphaNumericPattern = 0;
        this.alphaNumericErrorVisibility = true;

        this.indexCheckFlag = false;
        this.indexCount = 0;
        this.count = 0;
        this.duplicate = 0;
        this.pattern = 0;
        this.patternErrorVisibility = true;
        this.duplicateErrorVisibility = true;
        this.inputMode = "local";
        for (let j = 0; j < this.localIndex.length; j++) {
            if (index == this.localIndex[j]) {
                this.indexCount++;
            }
        }
        if (this.indexCount !== this.localIndex.length) {
            this.indexCheckFlag = true;

        }

        if (item != undefined) {
            if (item.length > 3) {
                this.pattern += 1;
                this.showError();
                this.specialLocalOptions[index] = null;
                item = "";
            } if (!item.match(regExpAlphaNumeric)) {
                this.alphaNumericPattern += 1;
                this.showError();
                this.specialLocalOptions[index] = null;
                this.localSelected[index] = "";
            } else {
                for (let j = 0; j < this.localSelected.length; j++) {
                    if (item !== this.localSelected[j]) {
                        this.count++;
                    }
                }
                if (this.count == this.localSelected.length && item != "") {
                    this.localSelected.push(item);
                    this.localIndex.push(index);
                }
                else {
                    if (this.count == 0 && this.indexCount == 0) {
                        this.indexCheckFlag = false;
                    }
                    if (this.indexCount == 0 && this.count != 0) {
                        this.indexCheckFlag = false;
                    }
                    if (this.indexCount !== 0 && this.count == 0) {
                        this.indexCheckFlag = true;
                    }
                    if (!this.indexCheckFlag && item != "") {
                        this.duplicate += 1;
                        this.showError();
                        this.specialLocalOptions[index] = null;
                    }
                }
            }
                for (let i = 0; i < this.localSelected.length; i++) {
                    if (this.localSelected[i] === "" ) {
                        this.localSelected.splice(i, 1);
                    
                }
            }
        }
        this.priceService.notifyNormalCompItem({ fromComponent: "normalLocal", data: [this.localSelected] });
        //this.progressBarService.progressBarValidation();
    }
    onPackageOptionClick(item, index) {
        let regExpAlphaNumeric = /^[A-Za-z0-9]+$/;
        this.alphaNumericPattern = 0;
        this.alphaNumericErrorVisibility = true;

        this.indexCheckFlag = false;
        this.indexCount = 0;
        this.count = 0;
        this.duplicate = 0;
        this.pattern = 0;
        this.patternErrorVisibility = true;
        this.duplicateErrorVisibility = true;
        this.inputMode = "package";
        this.inputMode = "local";
        for (let j = 0; j < this.packageIndex.length; j++) {
            if (index == this.packageIndex[j]) {
                this.indexCount++;
            }
        }
        if (this.indexCount !== this.packageIndex.length) {
            this.indexCheckFlag = true;

        }
        if (item != undefined) {
            if (item.length > 3) {
                this.pattern += 1;
                this.showError();
                this.specialPackageOptions[index] = null;
                item = "";
            } if (!item.match(regExpAlphaNumeric)) {
                this.alphaNumericPattern += 1;
                this.showError();
                this.specialPackageOptions[index] = null;
                this.packageSelected[index] = "";
            } else {
                for (let j = 0; j < this.packageSelected.length; j++) {
                    if (item != this.packageSelected[j]) {
                        this.count++;
                    }
                }
                if (this.count === this.packageSelected.length && item != "") {
                    this.packageSelected.push(item);
                    this.packageIndex.push(index);

                }
                else {
                    if (this.count == 0 && this.indexCount == 0) {
                        this.indexCheckFlag = false;
                    }
                    if (this.indexCount == 0 && this.count != 0) {
                        this.indexCheckFlag = false;
                    }
                    if (this.indexCount !== 0 && this.count == 0) {
                        this.indexCheckFlag = true;
                    }
                    if (!this.indexCheckFlag && item != "") {
                        this.duplicate += 1;
                        this.showError();
                        this.specialPackageOptions[index] = null;
                    }
                }
            }
                for (let i = 0; i < this.packageSelected.length; i++) {
                    if (this.packageSelected[i] === "" ) {
                        this.packageSelected.splice(i, 1);
                    
                }
            }
        }
        this.priceService.notifyNormalCompItem({ fromComponent: "normalPackage", data: [this.packageSelected] });
        //this.progressBarService.progressBarValidation();
    }

    deleteSelColorOpt() {
        this.colorSelected = "";
        this.priceService.notifyNormalCompItem({ fromComponent: "normalColor", data: [] });
        //this.progressBarService.progressBarValidation();
    }
    deleteSelAdcolorOpt() {
        this.addColorSelected = "";
        this.priceService.notifyNormalCompItem({ fromComponent: "normalAddColor", data: [] });
        // this.progressBarService.progressBarValidation();
    }

    deleteSelUpholsteryOpt() {
        this.upholsterySelected = "";
        this.priceService.notifyNormalCompItem({ fromComponent: "normalUpholstery", data: [] });
        //this.progressBarService.progressBarValidation();
    }

    deleteSelFactoryOpt(item) {
        for (let j = 0; j < this.factorySelected.length; j++) {
            if (item === this.factorySelected[j]) {
                this.factorySelected.splice(j, 1);
            }
        }
    }
    deleteSelLocOpt(item) {
        for (let j = 0; j < this.localSelected.length; j++) {
            if (item === this.localSelected[j]) {
                this.localSelected.splice(j, 1);
            }
        }
    }
    deleteSelPacOpt(item) {
        for (let j = 0; j < this.packageSelected.length; j++) {
            if (item === this.packageSelected[j]) {
                this.packageSelected.splice(j, 1);
            }
        }
    }
    acceptConfiguration() {

        this.dataLoaderService.flagDictionary.specialSuccessFlag = true;
        this.dataLoaderService.flagDictionary.specialCancelFlag = false;
        this.dataLoaderService.flagDictionary.specialResetFlag = false;
        this.dataLoaderService.flagDictionary.specialErrorFlag = false;
        this.submitDataSpecialMode();

        /* if (this.dataLoaderService.data.vehInfo[0].model === 'SMRT') {
             if ((this.colorSelected == undefined || this.colorSelected == "") && (this.addColorSelected == undefined ||
                 this.addColorSelected == "") && (this.upholsterySelected == "" && this.upholsterySelected == undefined)
                 && (this.trimSelected ==undefined || this.trimSelected =="") && (this.rimSelected == undefined ||
                 this.rimSelected == "") && (this.factorySelected == undefined || this.factorySelected.length == 0) && 
                 (this.localSelected == undefined || this.localSelected.length == 0) && (this.packageSelected == undefined 
                 || this.packageSelected.length != 0)) {
                 this.dataLoaderService.flagDictionary.specialSuccessFlag = true;
                 this.dataLoaderService.flagDictionary.specialCancelFlag = false;
                 this.dataLoaderService.flagDictionary.specialResetFlag = false;
                 this.dataLoaderService.flagDictionary.specialErrorFlag = false;
                 this.submitDataSpecialMode();
             }
             else {
                 this.dataLoaderService.flagDictionary.specialErrorFlag = true;
                 this.dataLoaderService.flagDictionary.specialCancelFlag = false;
                 this.dataLoaderService.flagDictionary.specialSuccessFlag = false;
                 this.dataLoaderService.flagDictionary.specialResetFlag = false;
             }
         }
         else {
             if ((this.colorSelected == undefined || this.colorSelected == "") && (this.upholsterySelected == "" && this.upholsterySelected == undefined)
                 && (this.trimSelected ==undefined || this.trimSelected =="") && (this.rimSelected == undefined ||
                 this.rimSelected == "") && (this.factorySelected == undefined || this.factorySelected.length == 0) && 
                 (this.localSelected == undefined || this.localSelected.length == 0) && (this.packageSelected == undefined 
                 || this.packageSelected.length != 0)) {
                 this.dataLoaderService.flagDictionary.specialSuccessFlag = true;
                 this.dataLoaderService.flagDictionary.specialCancelFlag = false;
                 this.dataLoaderService.flagDictionary.specialResetFlag = false;
                 this.dataLoaderService.flagDictionary.specialErrorFlag = false;
                 this.submitDataSpecialMode();
             }
             else {
                 this.dataLoaderService.flagDictionary.specialErrorFlag = true;
                 this.dataLoaderService.flagDictionary.specialSuccessFlag = false;
                 this.dataLoaderService.flagDictionary.specialCancelFlag = false;
                 this.dataLoaderService.flagDictionary.specialResetFlag = false;
 
             }
         }*/
    }
    openCancel() {
        this.dataLoaderService.flagDictionary.specialCancelFlag = true;
        this.dataLoaderService.flagDictionary.specialResetFlag = false;
        this.dataLoaderService.flagDictionary.specialErrorFlag = false;
        this.dataLoaderService.flagDictionary.specialSuccessFlag = false;
    }
    openReset() {
        this.dataLoaderService.flagDictionary.specialResetFlag = true;
        this.dataLoaderService.flagDictionary.specialSuccessFlag = false;
        this.dataLoaderService.flagDictionary.specialCancelFlag = false;
        this.dataLoaderService.flagDictionary.specialErrorFlag = false;
    }
    submitDataSpecialMode() {
        let configData = this.summaryService.submitSpecialModeData();
        (<HTMLInputElement>document.getElementById('acceptString')).value = configData + '';
        (<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
        (<HTMLFormElement>document.getElementById('form1')).submit();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/special-mode/special-mode.component.ts